module.exports = __webpack_public_path__ + "img/favicon.b8a657b1.png";